import { v4 as uuidv4 } from "uuid";
import { defaultData as HrDefaultData } from "@/react/components/shared/BuilderUI/DefaultBlocks/Content/LineBlock/HorizontalLineDefaultData";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export const createHrBlock = ({
  baseData = HrDefaultData,
  styles = {},
}: {
  baseData?: BaseBlock;
  styles?: Record<string, StyleValue>;
} = {}): BaseBlock => ({
  ...baseData,
  id: uuidv4(),
  props: {
    ...baseData.props,
    styles: {
      ...baseData?.props?.styles,
      prop: "styles",
      type: "styles",
      value: {
        ...(baseData?.props?.styles?.value as Record<string, StyleValue>),
        ...styles,
      },
    },
  },
});
